<template>
  <Dialog
      id="confirm-modal"
      v-model:visible="visible"
      :header="t('CONFIRM_TITLE')"
      modal
      :draggable="false"
      :dismissable-mask="true"
      @hide="onHide"
  >
    {{ msg }}

    <template #footer>
      <Button :label="t('CANCEL')" severity="secondary" @click="visible = false"/>
      <Button :label="t('CONFIRM')" @click="onConfirm"/>
    </template>
  </Dialog>
</template>

<script setup>
import {onBeforeUnmount, onMounted, ref} from "vue";
import {useI18n} from "vue-i18n";
import EventBus from "@/util/eventBus";

const { t } = useI18n();
const msg = ref("");
const callback = ref(() => {});
const visible = ref(false);

function onHide() {
  visible.value = false;
}

function onConfirm() {
  callback.value();
  visible.value = false;
}

onMounted(() => {
  EventBus.$on("show-confirmation-modal", showConfirmationModal);
});

onBeforeUnmount(() => {
  EventBus.$off("show-confirmation-modal", showConfirmationModal);
});

function showConfirmationModal(data) {
  visible.value = true;
  msg.value = data.msg;
  callback.value = data.callback;
}
</script>
